<template>
  <div class="inner-box" v-cloak>
		<div class="detail-social-block">
			<div class="back-link">
				<a href="../list.html" class="link">上映作品一覧</a>
			</div>
			<div class="next-link">
				<router-link v-if="film.prev" :to="{ name : 'filmrouter', params : { id: film.prev.film_identifier }}" class="link">&lt; 前の作品</router-link>
				<span class="separator">　|　</span>
				<router-link v-if="film.next" :to="{ name : 'filmrouter', params : { id: film.next.film_identifier }}" class="link">次の作品 &gt;</router-link>
			</div>
			<ul class="social-buttons _pc">
				<li class="like">
					<iframe :key="'fb1_' + film.film_identifier" :src="'https://www.facebook.com/plugins/like.php?href=https://2020.tiff-jp.net/ja/lineup/film/' + film.film_identifier + '&layout=button&action=like&size=small&show_faces=false&share=false'" scrolling="no" frameborder="0" style="border:none; overflow:hidden; width:72px; height:21px;" allowTransparency="true"></iframe>
				</li>
				<Tweet v-if="showTweet" :url="'https://2020.tiff-jp.net/ja/lineup/film/' + film.film_identifier" :lang="'ja'" :text="'【' + film.title_ja + '】｜第33回東京国際映画祭 #TIFFJP #eiga'"></Tweet>
				<li v-if="showTweet" class="line">
					<span>
						<div class="line-it-button" data-lang="ja" data-type="share-a" style="display: none;"></div>
					</span>
				</li>
			</ul>
		</div>

		<div class="detail-masonry">
			<div class="detail-movie-info-1 masonry-item -main">
				<ul class="categories">
					<li class="category -main" v-if="film.department">
            <span>{{film.department.name_ja}}</span>
          </li>
					<li class="category" v-if="film.department_subtitle_ja">{{film.department_subtitle_ja}}</li>
					<li class="category" v-if="film.title_head_ja">{{film.title_head_ja}}</li>
				</ul>
				<div class="subject" v-if="film.title_ja">{{film.title_ja}}</div>
				<div class="subject -english" v-if="film.title_en">{{film.title_en}}<span class="original" v-show="film.original_title">[{{film.original_title}}]</span></div>
				<div class="director" v-if="film.director_ja">監督：{{film.director_ja}}<span class="original" v-show="film.director_original">[{{film.director_original}}]</span></div>
				<ul class="genre-list">
					<li v-if="film.is_genre_human_drama" class="genre -human">ヒューマンドラマ</li>
					<li v-if="film.is_genre_comedy" class="genre -comedy">コメディ</li>
					<li v-if="film.is_genre_love_story" class="genre -romance">ラブストーリー</li>
					<li v-if="film.is_genre_action" class="genre -action">アクション</li>
					<li v-if="film.is_genre_horror" class="genre -horror">ホラー</li>
					<li v-if="film.is_genre_suspense" class="genre -suspense">サスペンス</li>
					<li v-if="film.is_genre_sf_fantasy" class="genre -sf-fantasy">SF/ファンタジー</li>
					<li v-if="film.is_genre_youth" class="genre -youth-drama">青春</li>
					<li v-if="film.is_genre_music" class="genre -music">ミュージック</li>
					<li v-if="film.is_genre_eros" class="genre -eros">エロス</li>
					<li v-if="film.is_genre_documentary" class="genre -documentary">ドキュメンタリー</li>
					<li v-if="film.is_genre_animation" class="genre -animation">アニメーション</li>
				</ul>
				<div class="premiere">{{film.premier_ja}}</div>
				<div class="lang-link"><a :href="'/en/lineup/film/' + film.film_identifier">&gt; English</a></div>

        <Slider v-if="showSlide" :loaded="loaded" :film="film" @slideImageLoaded="slideImageLoaded"></Slider>

				<div class="meta">{{film.copyrights_ja}}</div>

				<ul class="social-buttons _sp">
					<li class="like">
						<iframe :key="'fb2_' + film.film_identifier" :src="'https://www.facebook.com/plugins/like.php?href=https://2020.tiff-jp.net/ja/lineup/film/' + film.film_identifier + '&layout=button&action=like&size=small&show_faces=false&share=false'" scrolling="no" frameborder="0" style="border:none; overflow:hidden; width:72px; height:21px;" allowTransparency="true"></iframe>
					</li>
					<Tweet v-if="showTweet" :url="'https://2020.tiff-jp.net/ja/lineup/film/' + film.film_identifier" :lang="'ja'" :text="'【' + film.title_ja + '】｜第33回東京国際映画祭 #東京国際映画祭 #TIFFJP #eiga'"></Tweet>
					<li v-if="showTweet" class="line">
						<span>
							<div class="line-it-button" data-lang="ja" data-type="share-a" style="display: none;"></div>
						</span>
					</li>
				</ul>

				<div v-if="film.is_report_link_ja" class="news_link"><a :href="'http://2020.tiff-jp.net/news/ja/?tag=' + film.film_identifier">&raquo;この作品のレポートを読む</a></div>
				<div class="caution-2 pre-br" v-if="film.film_guide_bk_ja" v-html="film.film_guide_bk_ja"></div>
				<div class="caution-1 pre-br" v-if="film.film_guide_red_ja" v-html="film.film_guide_red_ja"></div>

			</div>

			<div class="detail-schedule masonry-item -sub">
				<div class="title">スケジュール／チケット</div>
				<div class="body">
          <div v-if="ticketAlart" v-html="ticketAlart"></div>
					<div class="unit" v-for="act in film.acts" :key="act.id">
						<div class="theater">{{act.venue.name_ja}}</div>
						<div class="show">
							<span v-if="act.act_date" class="date">{{act.act_date | dateformat}}</span>
							<span v-if="act.act_date" class="week">[{{act.act_date | dayformat}}]</span>
							<span v-if="act.open_at" class="time">{{act.open_at | timeformat}}-</span>
							<span class="running-time">（本編{{film.film_time_length}}分）</span>
              <span v-if="act.ticket_status == 3" class="seat -status-1">◎</span>
              <span v-if="act.ticket_status == 2" class="seat -status-2">△</span>
              <span v-if="act.ticket_status == 1" class="seat -status-3">✕</span>
              <span v-if="act.ticket_status == 0" class="seat">-</span>
						</div>
						<ul class="categories">
							<li v-if="act.is_event_qa" class="category -qanda">Q&amp;A</li>
							<li v-if="act.is_event_sa" class="category -greeting">舞台挨拶</li>
							<li v-if="act.is_event_ts" class="category -talkshow">トークショー</li>
							<li v-if="act.is_event_award" class="category -award-ceremony">授賞式</li>
							<li v-if="act.is_event_event" class="category -event">オンラインイベント</li>
						</ul>
						<div class="guest pre-br" v-if="act.guest_ja" v-html="act.guest_ja"></div>
						<div class="caution pre-br" v-if="act.guest_guide_ja" v-html="act.guest_guide_ja"></div>
						<div class="price">
              <span class="price_main" v-if="act.ticket_price_ja" v-html="act.ticket_price_ja"></span>
              <div class="note" v-if="act.ticket_price_s_ja" v-html="act.ticket_price_s_ja"></div>
						</div>
						<div class="price">
							<span v-if="act.is_show_flag_free" class="price_main">無料</span>
							<span v-if="act.is_show_flag_advanced" class="preceding-lottery">TIFFトークサロン</span>
							<span v-if="act.is_show_flag_application" class="pre-registration">事前申込み制</span>
							<div v-if="act.is_show_flag_end" class="cut-off">受付終了</div>
						</div>
						<div class="accepted-method pre-br" v-if="act.application_method_ja" v-html="act.application_method_ja"></div>
						<div class="guide-note1 pre-br" v-if="act.guide_bk_ja" v-html="act.guide_bk_ja"></div>
						<div class="guide-note2 pre-br" v-if="act.guide_rd_ja" v-html="act.guide_rd_ja"></div>
						<div v-if="act.saling_status == 2" class="button">
              <a :href="ticketPath + '/?performanceId=' + act.sales_identifier + '&locale=ja'" data-category="Films-ja" data-action="click" :data-label="film.film_identifier +' '+ act.act_date +' '+ act.open_at" class="link" target="_blank">オンラインチケット サイトへ</a>
            </div>
						<div v-if="act.saling_status == 1" class="button -disabled">オンラインチケット サイトへ</div>
					</div>

					<div v-if="film.is_show_seats" class="ticket_important important2">
						<div class="hl">残席状況</div>
						<div class="icon_info">
							<span class="seat -status-1">◎</span>：余裕あり
							<span class="seat -status-2">△</span>：残りわずか
							<span class="seat -status-3">✕</span>：チケット完売
						</div>
						<div class="note">※完売した上映であっても、状況により追加販売を行う可能性がございます。</div>
						<div class="news qa"></div>
					</div>
          <div v-if="film.acts && film.acts.length" class="notes">
						<div class="note -no4">価格は全て税込みです。</div>
						<div class="note -no1">登壇ゲストはすべて予定です。変更となる場合がございます。あらかじめご了承ください。</div>
					</div>
				</div>
			</div>

			<div class="detail-movie-info-2 masonry-item -main">
				<div v-if="film.abstract_ja">
					<div class="title">あらすじ</div>
					<div class="text pre-br" omit-tag="true" v-html="film.abstract_ja"></div>
				</div>
				<div v-if="film.exp_ja">
					<div class="title">作品解説</div>
					<div class="text pre-br" omit-tag="true" v-html="film.exp_ja"></div>
				</div>
				<div class="title">作品情報</div>
				<table class="about">
					<tr v-if="film.director_ja">
						<th>監督</th>
						<td>{{film.director_ja}}
              <span class="original" v-show="film.director_original">[{{film.director_original}}]</span>
							<p class="biography pre-br" v-html="film.director_profile_ja"></p>
						</td>
					</tr>
					<tr v-if="film.staffs && film.staffs.length">
						<th>スタッフ</th>
						<td>
							<p v-for="s in film.staffs" :key="s.id" v-show="s.name_ja">
								{{s.position_ja}}：{{s.name_ja}}
							</p>
						</td>
					</tr>
					<tr v-if="film.performers && film.performers.length">
						<th>キャスト</th>
						<td>
							<p v-for="c in film.performers" :key="c.id">
								{{c.name_ja}}
							</p>
						</td>
					</tr>
					<tr v-if="film.url || film.facebook || film.twitter || film.instagram">
						<th>リンク</th>
						<td>
							<ul>
								<li v-if="film.url" class="site"><a :href="film.url" target="_blank">{{film.sitename_ja}}</a></li>
								<li v-if="film.facebook" class="sns"><a :href="film.facebook" target="_blank"><img src="/img/lineup/sns_facebook.png" alt=""></a></li>
								<li v-if="film.twitter" class="sns"><a :href="film.twitter" target="_blank"><img src="/img/lineup/sns_twitter.png" alt=""></a></li>
								<li v-if="film.instagram" class="sns"><a :href="film.instagram" target="_blank"><img src="/img/lineup/sns_instagram.png" alt=""></a></li>
							</ul>
						</td>
					</tr>
				</table>
				<ul class="meta">
					<li v-if="film.film_time_length">{{film.film_time_length}}分</li>
					<li v-if="film.color_ja">{{film.color_ja}}</li>
					<li v-if="film.film_lang_ja">{{film.film_lang_ja}}</li>
					<li v-if="film.acts && film.acts.length">{{film.acts[0].subtitle_ja}}</li>
					<li v-if="film.made_year">{{film.made_year}}年</li>
					<li v-if="film.made_in_ja">{{film.made_in_ja}}</li>
					<li v-if="film.company_ja">{{film.company_ja}}</li>
				</ul>
				<div class="pagetop"><a href="#pagetop">↑このページの先頭へ</a></div>
				<div class="others-link">
					<div class="hl">他の上映作品</div>
					<div class="body">
						<div v-if="film.prev" class="work-left"><router-link :to="{ name : 'filmrouter', params : { id: film.prev.film_identifier }}">
							<div class="maincut"><img :src="'/img/lineup/cut/' + film.prev.film_identifier + '_1.jpg'" alt=""></div>
							<div class="category">{{film.prev.department.name_ja}}</div>
							<div class="subject">{{film.prev.title_ja}}</div>
							<div class="meta">{{film.prev.copyrights_ja}}</div>
						</router-link></div>
						<div v-if="film.next" class="work-right"><router-link :to="{ name : 'filmrouter', params : { id: film.next.film_identifier }}">
							<div class="maincut"><img :src="'/img/lineup/cut/' + film.next.film_identifier + '_1.jpg'" alt=""></div>
							<div class="category">{{film.next.department.name_ja}}</div>
							<div class="subject">{{film.next.title_ja}}</div>
							<div class="meta">{{film.next.copyrights_ja}}</div>
						</router-link></div>
					</div>
				</div>
			</div>

      <div v-if="ticketInfo" v-html="ticketInfo"></div>

			<div class="footer _sp"><div class="pagetop"><a href="#pagetop">↑このページの先頭へ</a></div></div>
		</div>

  </div>
</template>

<style scoped>
  .v-cloak ,
  [v-cloak] {
    visibility:hidden;
  }
  .pre-br {
    white-space: pre-wrap;
  }
</style>

<script>

import axios from 'axios'
import film from '../mixins/film'
import {apiEnv,envYear} from '../env.js'

var apiPath = apiEnv()
var eventYear = envYear

console.log(eventYear)

export default {
  name: 'Film',
  mixins: [film],
  methods: {
		redirectList () {
			document.location = "/ja/lineup/list.html"
		},
		insertMeta (data) {
			document.title = '【'+data.data.title_ja+'】 | 第33回東京国際映画祭'
		}
  },
  created () {
    axios
      .get('/ja/include/lineup_ticket_alart.inc')
      .then((res) => {
        this.ticketAlart = res.data
      })
    axios
      .get('/ja/include/lineup_ticket_info.inc')
      .then((res) => {
        this.ticketInfo = res.data
      })
  }
}
</script>



// WEBPACK FOOTER //
// src/templates/Film.vue